import { Routes } from '@angular/router';
import { MfAuthGuard } from '@meddev/fe-shared';
import { IndexComponent } from './_modules/index/index.component';
import { ThmIndexMenuComponent } from './_theme/thm-index-menu/thm-index-menu.component';

export const routes: Routes = [
    {
        path: 'public',
        loadChildren: () => import('./_modules/public/public.routes').then(m => m.publicRoutes),
    },
    { path: '', redirectTo: 'index', pathMatch: 'full' },
    {
        path: '',
        component: ThmIndexMenuComponent,
        canActivateChild: [MfAuthGuard],
        children: [
            {
                path: 'index',
                component: IndexComponent,
            },
            {
                path: 'settings',
                loadChildren: () => import('./_modules/settings/settings.routes').then(m => m.settingsRoutes),
            },
            {
                path: 'booking',
                loadChildren: () => import('./_modules/booking/booking.routes').then(m => m.bookingRoutes),
            },
            {
                path: 'slots',
                loadChildren: () => import('./_modules/slots/slots.routes').then(m => m.slotsRoutes),
            },
            {
                path: 'reservations-list',
                loadChildren: () => import('./_modules/reservations/reservations.routes').then(m => m.reservationsRoutes),
            },
            {
                path: 'workers',
                loadChildren: () => import('./_modules/workers/workers.routes').then(m => m.workersRoutes),
            },
            {
                path: 'working-groups',
                loadChildren: () => import('./_modules/working-groups/working-groups.routes').then(m => m.workingGroupsRoutes),
            },
            {
                path: 'analytics',
                loadChildren: () => import('./_modules/analytics/analytics.routes').then(m => m.analyticsRoutes),
            },
            {
                path: 'contractor-network',
                loadChildren: () => import('./_modules/contractor-network/contractor-network.routes').then(m => m.contractorNetworkRoutes),
            },
        ],
    },
    { path: '**', redirectTo: '/index' },
];
